import React, { useState } from 'react';
import { User, X, ShoppingCart, ExternalLink } from 'lucide-react';
import { useCart } from '../../../context/CartContext';
import './TalentCard.css';

const TalentCard = ({ talent }) => {
  const [showModal, setShowModal] = useState(false);
  const { addToCart } = useCart();

  const handleAddToCart = () => {
    addToCart({
      id: talent.id,
      type: 'talent',
      name: talent.name,
      price: talent.rate,
      data: talent,
      image: talent.image,
    });
    setShowModal(false);
  };

  return (
    <>
      {/* Card */}
      <div className="talent-card" onClick={() => setShowModal(true)}>
        <div className="tal-card-image">
          {talent.image ? (
            <img src={talent.image} alt={`${talent.name} - ${talent.category || 'Film professional'} for hire in Chicago`} />
          ) : (
            <div className="tal-card-placeholder">
              <User size={40} />
            </div>
          )}
          {!talent.available && (
            <div className="tal-card-badge">Booked</div>
          )}
        </div>
        <div className="tal-card-content">
          <div className="tal-card-category">{talent.category}</div>
          <h3 className="tal-card-title">{talent.name}</h3>
          <p className="tal-card-meta">{talent.experience}</p>
          <div className="tal-card-footer">
            <span className="tal-card-price">${talent.rate}/day</span>
            <span className="tal-card-link">View Profile →</span>
          </div>
        </div>
      </div>

      {/* Modal */}
      {showModal && (
        <div className="tal-modal-overlay" onClick={() => setShowModal(false)}>
          <div className="tal-modal" onClick={(e) => e.stopPropagation()}>
            <button className="tal-modal-close" onClick={() => setShowModal(false)}>
              <X size={24} />
            </button>

            <div className="tal-modal-grid">
              {/* Image */}
              <div className="tal-modal-image">
                {talent.image ? (
                  <img src={talent.image} alt={`${talent.name} - ${talent.category || 'Film professional'} for hire in Chicago`} />
                ) : (
                  <div className="tal-modal-placeholder">
                    <User size={64} />
                  </div>
                )}
              </div>

              {/* Details */}
              <div className="tal-modal-details">
                <div className="tal-modal-category">{talent.category}</div>
                <h2 className="tal-modal-title">{talent.name}</h2>
                
                <p className="tal-modal-experience">{talent.experience} experience</p>

                <div className="tal-modal-info">
                  {talent.skills && (
                    <div className="tal-info-row">
                      <span className="tal-info-label">Skills:</span>
                      <span className="tal-info-value">{talent.skills}</span>
                    </div>
                  )}
                  <div className="tal-info-row">
                    <span className="tal-info-label">Status:</span>
                    <span className={`tal-info-value ${talent.available ? 'available' : 'unavailable'}`}>
                      {talent.available ? 'Available' : 'Booked'}
                    </span>
                  </div>
                </div>

                {talent.bio && (
                  <div className="tal-modal-description">
                    <h4>Bio</h4>
                    <p>{talent.bio}</p>
                  </div>
                )}

                {talent.portfolio && (
                  <a 
                    href={talent.portfolio} 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="tal-portfolio-link"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <ExternalLink size={16} />
                    View Portfolio
                  </a>
                )}

                <div className="tal-modal-actions">
                  <div className="tal-modal-price">
                    <span className="tal-price-label">Daily Rate</span>
                    <span className="tal-price-value">${talent.rate}</span>
                  </div>
                  <button 
                    onClick={handleAddToCart}
                    className="btn btn-primary"
                    disabled={!talent.available}
                  >
                    <ShoppingCart size={18} />
                    Add to Cart
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default TalentCard;